import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCodeS = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M8.42105 8L4 12L8.42105 16M15.5789 8L20 12L15.5789 16",
		stroke: "white",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgCodeS;
